module.exports = __webpack_public_path__ + "static/assets/bd7f87fab548492fc7bb81e2a1fe5681.png";